export class Utilities {
  static clone(object: any) {
    return object ? JSON.parse(JSON.stringify(object)) : object;
  }
}

export const getBaseApplicationRoutePath = () => {
  return window.location.href?.includes('/support/help') ? '/support/help' : '/help';
};

export const isElementInView = (myElement) => {
  if (!myElement) {
    return false;
  }
  const rectangleBounding = myElement.getBoundingClientRect();
  const myElementHeight = myElement.offsetHeight;
  const myElementWidth = myElement.offsetWidth;

  if (
    rectangleBounding.top >= -myElementHeight &&
    rectangleBounding.left >= -myElementWidth &&
    rectangleBounding.right <= (window.innerWidth || document.documentElement.clientWidth) + myElementWidth &&
    rectangleBounding.bottom <= (window.innerHeight || document.documentElement.clientHeight) + myElementHeight
  ) {
    return true;
  } else {
    return false;
  }
};
